// extracted by mini-css-extract-plugin
export default {"root":"app-react-portainer-HomeView-EdgeLoadingSpinner-module__root"};